import { createAction, props } from '@ngrx/store';

import { KeyImage } from '../services/imaging/common';

export const seReportNullAction = createAction('[SeReport] NullAction');

export const seReportApproveCompleted = createAction(
    '[SeReport] ApproveCompleted',
    props<{ error?: boolean; modules: string[] }>(),
);

export const seReportSave = createAction('[SeReport] Save');

export const seReportSaveCompleted = createAction('[SeReport] SaveCompleted', props<{ error: boolean }>());

export const seReportSetIsModified = createAction('[SeReport] SetIsModified', props<{ isModified: boolean }>());

export const seReportSetIsPreview = createAction('[SeReport] SetIsPreview', props<{ isPreview: boolean }>());

export const seReportSetPatientId = createAction('[SeReport] SetPatientId', props<{ patientId: string | null }>());

export const seReportDeleteKeyImages = createAction('[SeReport] DeleteKeyImages', props<{ keyImages: KeyImage[] }>());

export const seReportSetKeyImages = createAction('[SeReport] SetKeyImages', props<{ keyImages: KeyImage[] }>());

export const seReportSetImagesPerRowInPlaceholder = createAction(
    '[SeReport] SetImagesPerRowInPlaceholder',
    props<{ imagesPerRowInPlaceholder: number }>(),
);

export const seReportSetCurrentExaminationIdsEcg = createAction(
    '[SeReport] SetCurrentExaminationIdsEcg',
    props<{ ids: string[] }>(),
);

export const seReportSetCurrentExaminationIdsVisit = createAction(
    '[SeReport] SetCurrentExaminationIdsVisit',
    props<{ ids: string[] }>(),
);

export const seReportApplyNormalValues = createAction('[SeReport] ApplyNormalValues');
